// extracted by mini-css-extract-plugin
export var box = "ThankYoyBox-module--box--9481a";
export var content = "ThankYoyBox-module--content--f2386";
export var subscriptionConfirmedMessage = "ThankYoyBox-module--subscription-confirmed-message--88da2";
export var title = "ThankYoyBox-module--title--fae81";